import http from './http';

// Empresas
export const listCompanies = async () => {
  const { data } = await http.get('/clients/companies');
  return data; // ahora incluye service_type
};

export const createCompany = async ({ name, file, stripe_color, service_type }) => {
  const fd = new FormData();
  fd.append('name', name);
  if (file) fd.append('logo', file);
  if (stripe_color !== undefined) fd.append('stripe_color', stripe_color);
  if (service_type !== undefined) fd.append('service_type', service_type || '');
  const { data } = await http.post('/clients/companies', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const updateCompany = async (id, { name, file, stripe_color, service_type }) => {
  const fd = new FormData();
  if (name != null) fd.append('name', name);
  if (file) fd.append('logo', file);
  if (stripe_color !== undefined) fd.append('stripe_color', stripe_color || '');
  if (service_type !== undefined) fd.append('service_type', service_type || '');
  const { data } = await http.put(`/clients/companies/${id}`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const deleteCompany = async (id) => {
  const { data } = await http.delete(`/clients/companies/${id}`);
  return data;
};

// Sucursales
export const createBranch = async (payload) => {
  const { data } = await http.post('/clients/branches', payload); // payload puede incluir service_type
  return data;
};

export const updateBranch = async (id, payload) => {
  const { data } = await http.put(`/clients/branches/${id}`, payload); // idem
  return data;
};

export const listBranches = async (companyId) => {
  const { data } = await http.get('/clients/branches', { params: companyId ? { company_id: companyId } : {} });
  return data; // ahora incluye service_type
};

export const deleteBranch = async (id) => {
  const { data } = await http.delete(`/clients/branches/${id}`);
  return data;
};

// Página pública (no cambia firma, ahora regresa { service_name, clients[] })
export const fetchClientsGrouped = async () => {
  const { data } = await http.get('/clients/grouped');
  return data;
};



